import { createSelector } from '@ngrx/store';
import { AssetsCollection } from '@gelato-api-ui/core/designs/assets-collection';
import { State } from './assets.reducer';

export const getState = (state): State => state.productCatalogue.assets;

export const getAssetsCollection = createSelector(getState, (state: State): AssetsCollection => state.assetsCollection);
